import Alpine from 'alpinejs'
import { debounce } from './utilities.js';
import { initLandingGradients } from './landing-gradient.js';

window.Alpine = Alpine
Alpine.start()

initLandingGradients()
